// extracted by mini-css-extract-plugin
module.exports =  {"grid":"_93444fe79c--grid--PTXgq","large":"_93444fe79c--large--rBLD0"};